<template>
  <main id="app" class="app-root">
    <Navbar class="Navbar" />

    <router-view />

    <div class="copyright-wrapper">
      <p class="copyright ff-en-1 fz-13 fz-mbl-12 c-100">
        Copyright © 2008-2024 GANGA7. All Rights Reserved.
      </p>

      <ButtonGoTop />
    </div>
  </main>
</template>

<script>
import Navbar from "@/components/Navbar.vue";
import ButtonGoTop from "@/components/ButtonGoTop.vue";

export default {
  name: "App",
  components: { Navbar, ButtonGoTop },

  computed: {},

  methods: {},
};
</script>

<style lang="scss">
.app-root {
  background-color: #040c1a;
}

.Navbar {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1000;
}

.copyright-wrapper {
  display: flex;
  justify-content: center;
  align-items: center;

  padding: vw-dsk(20) vw-dsk($page-margin-x);
  color: #fff;

  @include mq(mbl) {
    padding: vw-mbl(8) vw-mbl($page-margin-x-mbl);
  }
  @include mq(mx-500) {
    padding: vw-mbl(15) vw-mbl($page-margin-x-mbl);
  }

  .copyright {
    @include mq(mbp) {
      padding-right: 100px;
    }

    padding-right: 0;
  }
}
</style>
